import { FC, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { $ABTest, $RootTraffic, $UserAgent, $WebUser } from '@lemon8/web-app-shared/atom';

export const SmartBannerMeta: FC = () => {
  const { isiOS } = useAtomValue($UserAgent);

  if (isiOS) {
    return (
      <meta
        name="apple-itunes-app"
        content="app-id=1498607143, affiliate-data=pt=125533089&ct=website_seo_homepage_smart_banner"
      />
    );
  }
};

export const SmartBannerPixel: FC = () => {
  const { versions } = useAtomValue($ABTest);
  const { trafficPid } = useAtomValue($RootTraffic);
  const { webId } = useAtomValue($WebUser);
  const { isiOS } = useAtomValue($UserAgent);

  const onelink = useMemo(() => {
    const url = new URL('https://lemon8.onelink.me/FMQw');
    url.searchParams.set('pid', 'website_homepage');
    url.searchParams.set(
      'amp_extra',
      JSON.stringify({
        enter_position: 'smart_banner',
        enter_page_type: 'website_homepage',
        enter_page_id: 'website_homepage',
        traffic_type: trafficPid,
        web_id: webId,
      }),
    );
    url.searchParams.set('ab_version', versions);

    return url.toString();
  }, []);

  if (isiOS) {
    return <img height={1} width={1} style={{ position: 'absolute' }} src={onelink} />;
  }
};
